<div class="p-3 py-5 container rounded rounded-3">
  <app-news-feed class="news border border-secondary rounded rounded-3 overflow-hidden" [fullpage]="true"></app-news-feed>
</div>
<div class="background"><fa-icon [fixedWidth]="true" [icon]="backIcon"></fa-icon></div>
